export class AccountOrganizationRole {
  constructor(init: Partial<AccountOrganizationRole> = {}) {
    this.id = init.id || 0
    this.name = init.name || ''
  }

  id: number
  name: string
}
